import styled from "styled-components";
import ThemeColors from "../../themes/colors";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${ThemeColors.Bg2500};
  height: 100%;
  width: 100%;
`;

export const ContentContainer = styled.div`
  height: 100%;
  overflow: auto;
`;

export const ChildrenContainer = styled.div`
  display: flex;
  padding: 2rem;
  margin-left: 22rem;
`;
